import { IMPACT_META, type MarketEvent } from '@/mocks/marketCalendar';
import { eventTimestamp, formatCountdown, minutesToLabel, toUtcMinutes } from '../calculations';
import { CurrencyFlag } from './ui';

export default function UpcomingEvents({
  events,
  now,
  toDisplay,
  onSelect,
}: {
  events: MarketEvent[];
  now: number;
  toDisplay: (utc: number) => number;
  onSelect: (e: MarketEvent) => void;
}) {
  if (events.length === 0) {
    return (
      <div className="rounded-2xl border border-slate-200/80 bg-slate-50 py-10 text-center">
        <p className="text-sm text-slate-400">Không có sự kiện sắp diễn ra trong bộ lọc hiện tại.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
      {events.map((e) => {
        const meta = IMPACT_META[e.impact];
        const ts = eventTimestamp(e);
        const diff = ts - now;
        const displayTime = minutesToLabel(toDisplay(toUtcMinutes(e.time)));
        const state = diff <= 0 ? 'released' : diff <= 10 * 60000 ? 'now' : 'in';
        return (
          <button
            key={e.id}
            type="button"
            onClick={() => onSelect(e)}
            className="group flex flex-col rounded-2xl border border-slate-200/80 bg-white p-4 text-left transition-all hover:-translate-y-0.5 hover:border-violet-200"
          >
            <div className="flex items-center justify-between">
              <span className="font-mono text-sm font-bold tabular-nums text-slate-800">{displayTime}</span>
              <span
                className={`rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${
                  state === 'in' ? 'bg-slate-100 text-slate-500' : state === 'now' ? 'bg-violet-600 text-white' : 'bg-emerald-50 text-emerald-600'
                }`}
              >
                {state === 'in' ? 'In' : state === 'now' ? 'Now' : 'Released'}
              </span>
            </div>
            <p className="mt-2 flex items-center gap-2 text-sm font-semibold text-slate-900 group-hover:text-violet-700">
              <CurrencyFlag code={e.currency} />
              {e.title}
            </p>
            <p className="mt-1 font-mono text-[11px] text-slate-400">{e.currency}</p>
            <div className="mt-3 flex items-center justify-between">
              <span className="inline-flex items-center gap-1.5" style={{ color: meta.color }}>
                {Array.from({ length: 3 }).map((_, i) => (
                  <span key={i} className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: i < meta.dots ? meta.color : '#e2e8f0' }} />
                ))}
                <span className="text-[11px] font-semibold">{meta.label}</span>
              </span>
              <span className="font-mono text-sm font-bold tabular-nums text-violet-600">
                {state === 'in' ? formatCountdown(diff) : '—'}
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
}